import {
  //
  ADD_NETWORK,
  ADD_NETWORK_FAILURE,
  ADD_NETWORK_SUCCESS,
  //
  DELETE_NETWORK,
  DELETE_NETWORK_FAILURE,
  DELETE_NETWORK_SUCCESS,
  //
  EDIT_NETWORK,
  EDIT_NETWORK_FAILURE,
  EDIT_NETWORK_SUCCESS,
  //
  FETCH_NETWORK,
  FETCH_NETWORK_FAILURE,
  FETCH_NETWORK_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_NETWORK,
  SEARCH_NETWORK_FAILURE,
  SEARCH_NETWORK_SUCCESS,
} from "./constants";

// List
export const fetchNetwork = (payload) => ({
  type: FETCH_NETWORK,
  payload,
});
export const fetchNetworkSuccess = (payload) => ({
  type: FETCH_NETWORK_SUCCESS,
  payload,
});
export const fetchNetworkFailure = (payload) => ({
  type: FETCH_NETWORK_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addNetwork = (payload) => ({
  type: ADD_NETWORK,
  payload,
});
export const addNetworkSuccess = (payload) => ({
  type: ADD_NETWORK_SUCCESS,
  payload,
});
export const addNetworkFailure = (payload) => ({
  type: ADD_NETWORK_FAILURE,
  payload,
});
// EDIT
export const editNetwork = (payload) => ({
  type: EDIT_NETWORK,
  payload,
});
export const editNetworkSuccess = (payload) => ({
  type: EDIT_NETWORK_SUCCESS,
  payload,
});
export const editNetworkFailure = (payload) => ({
  type: EDIT_NETWORK_FAILURE,
  payload,
});
// DELETE
export const deleteNetwork = (payload) => ({
  type: DELETE_NETWORK,
  payload,
});
export const deleteNetworkSuccess = (payload) => ({
  type: DELETE_NETWORK_SUCCESS,
  payload,
});
export const deleteNetworkFailure = (payload) => ({
  type: DELETE_NETWORK_FAILURE,
  payload,
});
export const searchNetwork = (payload) => ({
  type: SEARCH_NETWORK,
  payload,
});
export const searchNetworkSuccess = (payload) => ({
  type: SEARCH_NETWORK_SUCCESS,
  payload,
});
export const searchNetworkFailure = (payload) => ({
  type: SEARCH_NETWORK_FAILURE,
  payload,
});
